import { render, staticRenderFns } from "./RinvPD_Details.vue?vue&type=template&id=addbb6bc"
import script from "./RinvPD_Details.vue?vue&type=script&lang=js"
export * from "./RinvPD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports